/** @format */

import React, { useEffect, useState } from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Container from 'react-bootstrap/Container';
import Intro from 'views/Registration/HomePage/Intro';
import Partners from 'views/Registration/HomePage/Partners';
import Benefits from 'views/Registration/HomePage/Benefits';
import WhatWeDo from 'views/Registration/HomePage/WhatWeDo';
import FeeCalculator from 'views/Registration/HomePage/FeeCalculator';
import StickyAnimations from 'views/Registration/HomePage/StickyAnimations';
import { REGISTER_TYPE } from 'views/Registration/Register';
import { Helmet } from 'react-helmet-async';
import PageLoader from 'components/PageLoader';

import config from 'config';

export default function HomePage(props) {
  const { tprop, registerType = null } = props;

  const { formID: klaviyoFormId, apiKey: klaviyoApiKey } = config.app.klaviyo;

  const [isKlaviyoPopupPresent, setIsKlaviyoPopupPresent] = useState(false);
  const [first3Seconds, setFirst3Seconds] = useState(true);

  useEffect(() => {
    if (registerType === REGISTER_TYPE.BROKER) {
      setTimeout(() => {
        setFirst3Seconds(false);
      }, 3000);
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', klaviyoFormId]);

      const checkKlaviyoPopup = () => {
        const element = document.querySelector('[data-testid="FULLSCREEN"]');
        setIsKlaviyoPopupPresent(!!element);
      };

      checkKlaviyoPopup();

      const observer = new MutationObserver(checkKlaviyoPopup);
      observer.observe(document.body, { childList: true, subtree: true });

      return () => {
        window._klOnsite = [];
        observer.disconnect();
      };
    }
  }, []);

  const HelmetMetadata = () => {
    if (registerType === REGISTER_TYPE.BROKER) {
      return (
        <Helmet>
          <script
            type='text/javascript'
            async=''
            src={`https://static.klaviyo.com/onsite/js/${klaviyoApiKey}/klaviyo.js`}></script>
        </Helmet>
      );
    }

    return <></>;
  };

  const CommonHome = () => {
    return (
      <div className='main-container homepage-view'>
        <Header showContactSellerButton={true} {...props} />

        <Container fluid className='content-wrapper'>
          <Intro {...props} tprop={tprop.intro} />

          <Partners {...props} tprop={tprop.partners} />

          <StickyAnimations {...props} tprop={tprop.whatWeOffer} />

          <FeeCalculator {...props} tprop={tprop.feeCalculator} />

          <Benefits {...props} tprop={tprop.benefits} />

          <WhatWeDo {...props} tprop={tprop.whatWeDo} />
        </Container>

        <Footer {...props} />
      </div>
    );
  };

  const LoadingScreen = () => {
    if (first3Seconds || isKlaviyoPopupPresent) {
      return (
        <div className='main-container homepage-view'>
          <Header showContactSellerButton={true} {...props} />
          <Container fluid className='broker-profile-loading-container'>
            <PageLoader />
          </Container>
          <Footer {...props} />
        </div>
      );
    } else {
      return <CommonHome />;
    }
  };

  return (
    <>
      <HelmetMetadata />
      {registerType === REGISTER_TYPE.BROKER ? (
        <LoadingScreen />
      ) : (
        <CommonHome />
      )}
    </>
  );
}
